export const userType = {
  CUSTOMER: 'Customer',
  MERCHANT: 'Merchant',
  DRIVER: 'Driver',
};
